<template>
  <div class="gallery" style="width: 100%; height:100%;">
    <swiper :options="swiperOption" ref="mySwiper" style="width: 100%; height:100%;">
      <swiper-slide :key="index" v-for="(slide, index) in getImages()">
        <img :src="slide.src" style="width:auto; margin:0 auto">
      </swiper-slide>
      <!-- Optional controls -->
      <!-- If we need pagination -->
      <div v-if="false" class="swiper-pagination"  slot="pagination"></div>

      <!-- If we need navigation buttons -->
      <div v-if="false" class="swiper-button-prev" slot="button-prev"></div>
      <div v-if="false" class="swiper-button-next" slot="button-next"></div>

      <!-- If we need scrollbar -->
      <div v-if="false" class="swiper-scrollbar"   slot="scrollbar"></div>
      <div v-if="false" class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>

<script>
  import 'swiper/dist/css/swiper.css';
  import { swiper, swiperSlide } from 'vue-awesome-swiper';

  export default {
    name: 'app-dash-swiper',
    components: {
      swiper,
      swiperSlide,
    },
    computed: {
      swiper() {
        return this.$refs.mySwiper.swiper;
      },
    },
    mounted() {

    },
    methods: {
      show: function (gallery) {
        this.gallery = gallery;
       // this.swiper.show();
      },
      getImages: function () {
        return this.gallery.images;
      },
    },
    data() {
      return {
        gallery: [],
        images: [],
        swiperOption: {
          // some swiper options/callbacks
          // 所有的参数同 swiper 官方 api 参数
          // ..
        },
      };
    },
  };
</script>

<style lang="css" rel="stylesheet/css" scoped>
  .slide-container{
    width: 100%;
    height: 100%;
  }
</style>




// WEBPACK FOOTER //
// Swiper.vue?6024d553